// Diego, junta del 13-oct: nada detiene el PDF salvo un PDF roto; un precio bajo es SUGERENCIA (Diego recibe el aviso).
// Los avisos de precio del motor todavía terminan en «este precio necesita el OK de Diego…»: a quien no autoriza ese texto
// le dice que está trabado. Recorrido a 390 px (13-oct, 18:30): en la pestaña PDF salían tres renglones «necesita su OK»
// justo debajo de «Sugerencia: el PDF sale igual». Aquí se quita esa cola; lo demás del aviso (cuánto bajó, el piso) queda.

const COLAS: readonly RegExp[] = [
  // «… Es un candado que solo abre Diego: este precio necesita su OK.»
  /\s*Es un candado que solo abre Diego:\s*este precio necesita su OK\.?/gi,
  // «…: este precio necesita el OK de Diego, Miguel o Juan Carlos.» / «…: necesita su OK.»
  /:\s*(este precio\s+)?necesita (el|su) OK[^.]*\.?/gi,
  // «… pierde dinero. Necesita el OK de Diego (o sube el precio, o revisa los costos adicionales).»
  /\s*Necesita el OK de Diego[^.]*?(\([^)]*\))?\.?$/gi,
];

/** El texto del aviso sin la parte que dice que hace falta un OK (para quien no autoriza: para él es sugerencia). */
export function sinPedirOk(mensaje: string): string {
  let t = mensaje;
  for (const r of COLAS) t = t.replace(r, '.');
  t = t.replace(/\s*\.\s*\./g, '.').replace(/\s+\./g, '.').trim();
  return t || mensaje;
}
